import {createModelSchema, primitive, identifier,} from 'serializr';

export class Geoloc {
    ip!: string
    iso_code!: string
    country!: string
    city!: string
    state!: string
    state_name!: string
    postal_code!: string
    lat!: number
    lon!: number
    timezone!: string
    continent!: string
    currency!: string
    default!: boolean
    cached!: boolean
}

createModelSchema(Geoloc, {
    ip: identifier(),
    iso_code: primitive(),
    country: primitive(),
    city: primitive(),
    state: primitive(),
    state_name: primitive(),
    postal_code: primitive(),
    lat: primitive(),
    lon: primitive(),
    timezone: primitive(),
    continent: primitive(),
    currency: primitive(),
    default: primitive(),
    cached: primitive(),
});
